import { render, staticRenderFns } from "./BindClaimsFromTarnModal.vue?vue&type=template&id=f134ed86&scoped=true&"
import script from "./BindClaimsFromTarnModal.vue?vue&type=script&lang=ts&"
export * from "./BindClaimsFromTarnModal.vue?vue&type=script&lang=ts&"
import style0 from "./BindClaimsFromTarnModal.vue?vue&type=style&index=0&id=f134ed86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f134ed86",
  null
  
)

export default component.exports